import { createAction } from "@reduxjs/toolkit";
import type { ExternalProviderBatchRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveExternalProviderBatchRequest = createApiThunk<ExternalProviderBatchRequestVM, string>(
  "externalProviderBatchRequests/adminRetrieveExternalProviderBatchRequest",
  async (requestId, { extra: { adminRepository } }) => {
    return adminRepository!.getExternalProviderBatchRequest(requestId);
  },
);

export const resetAdminRetrieveExternalProviderBatchRequest = createAction(
  "externalProviderBatchRequests/resetAdminRetrieveExternalProviderBatchRequest",
);
